<template>
  <header class="app-header">
    <div class="left-wrap">
      <button type="button" class="back-btn" v-if="!isMainPage" @click="goBack">
        <img :src="'/images/mobile/icon/back-arrow.svg'" alt="" />
      </button>

      <h1>{{ title }}</h1>
    </div>

    <div class="right-wrap">
      <button
        class="credit-btn"
        aria-label="credit"
        v-if="userStore.userInfo?.userType === 'HOST'"
        @click="goToPage('app-credit')"
      >
        <img :src="'/images/mobile/icon/credit-icon.svg'" alt="credit" />
        <span>{{ formatNumberWithComma(subscriptionStore.currentCredits) }}</span>
      </button>

      <IconHamburger class="icon" @click="goToPage('app-setting')" />
    </div>
  </header>
</template>

<script setup lang="ts">
import IconHamburger from '@/components/jh-app/icons/IconHamburger.vue';
import { setIsBack } from '@/router';
import { useSubscriptionStore } from '@/stores/subscription';
import { useUserStore } from '@/stores/user';
import { formatNumberWithComma } from '@/utils/stringUtils.js';

const { t } = useI18n();
const route = useRoute();
const router = useRouter();

const userStore = useUserStore();
const subscriptionStore = useSubscriptionStore();

const intervalId = ref<number>();

const title = computed(() => {
  const metaTitle = route.meta.title;

  if (typeof metaTitle === 'function') {
    return metaTitle(route);
  }
  if (typeof metaTitle === 'string') {
    return t(metaTitle);
  }

  return '';
});
const isMainPage = computed(() => route.path.includes('main'));

const setupSubscriptionInterval = async () => {
  intervalId.value = setInterval(async () => {
    await subscriptionStore.fetchSubscriptionInfo();
  }, 300000);
};

const goBack = () => {
  const destinationBack = String(router.options.history.state.back);

  if (destinationBack.includes('login')) {
    router.replace({ name: 'app-main-view' });
    return;
  }

  setIsBack(true);
  router.back();
};

const goToPage = (name) => {
  router.push({ name });
};

onBeforeMount(async () => {
  await subscriptionStore.initializeSubscriptionInfo();
  // await setupSubscriptionInterval();
});

onUnmounted(() => {
  clearInterval(intervalId.value);
});
</script>

<style scoped lang="scss"></style>
